// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .m-top-20 {\n  margin-top: 20px;\n}\n.input-width {\n  width: 100%;\n}\n[dir=ltr] .input-width {\n  margin-right: 10px;\n}\n[dir=rtl] .input-width {\n  margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
